import {
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from "@material-ui/core";

import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import DeleteIcon from "@material-ui/icons/Delete";
import * as React from "react";
import { getApi } from "../../api/ApiProvider";
import { ConfigData } from "../../config";
import { mockTheme } from "../../utils/utils";
import SelectAutocomplete from "../SelectAutocomplete";

const styles = (theme: Theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },

  buttons: {
    textAlign: "right",
  },

  success: {
    textAlign: "center",
  },
  cardMedia: {
    width: 400,
    height: 400,
    minHeight: 400,
    margin: "auto",
  },
  formControl: {
    margin: theme.spacing.unit * 2,
    minWidth: "60%",
  },
  formControlQuantity: {
    margin: theme.spacing.unit * 2,
    minWidth: "20%",
  },
  formControlObservation: {
    margin: theme.spacing.unit * 2,
    minWidth: "35%",
  },
  addProduct: {
    textAlign: "center",
    padding: 10,
    borderRadius: 5,
    borderStyle: "solid",
    borderWidth: "thin",
    borderColor: "#00000045",
  },
  gridTotal: {
    padding: 10,
    marginBottom: 25,
    textAlign: "right",
  },
});

const classesType = styles(mockTheme);

export interface OrderData {
  observation?: string;
  withMoney: boolean;
  driver: number | null;
  amount?: number;
  dueDate?: string;
  user: { name: string; document: string; phone?: string; email?: string };
  origin: {
    street1: string;
    street2?: string;
    number?: number;
    observation?: string;
  };
  destiny: {
    street1: string;
    street2?: string;
    number?: number;
    observation?: string;
  };
}

interface NewOrderProps extends WithStyles<keyof typeof classesType> {
  config: ConfigData;
  error?: any;
  companyId?: number;
  updateOrder: (data: any) => void;
  previousData: any[];
}

interface NewOrderState {
  data: OrderData | null;
  selectedProduct: any;
  selectedObservation: string;
  products: any[];
  rows: any[];
  selectedQuantity: number;
  total: number;
  productRef: any;
}

class NewOrderForm extends React.Component<NewOrderProps, NewOrderState> {
  constructor(props: NewOrderProps) {
    super(props);
    this.state = {
      data: null,
      selectedProduct: null,
      selectedObservation: "",
      products: [],
      rows: props.previousData || [],
      selectedQuantity: 1,
      total: 0,
      productRef: null,
    };

    this.getById = this.getById.bind(this);
    this.loadProducts = this.loadProducts.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.addProduct = this.addProduct.bind(this);
  }
  componentDidMount() {
    // this.setState({ products: products, selectedProduct: 0 })
    this.loadProducts();
  }

  loadProducts() {
    const company = this.props.companyId ? this.props.companyId : 1;
    getApi()
      .product()
      .listAvailable(company)
      .then((response) => {
        this.setState({ products: response, selectedProduct: 0 });
      });
  }

  getById = (id: number) => {
    return this.state.products.find((p) => p.id === id);
  };

  resetForm() {
    this.setState({ selectedProduct: 0, selectedQuantity: 1 });
  }

  addProduct() {
    const getTotal = (rows: any[]): number => {
      return rows.reduce((sum, p) => sum + p.quantity * p.price, 0);
    };
    const product = this.getById(this.state.selectedProduct);
    if (!product || this.state.selectedQuantity < 1) {
      return;
    }
    const row = {
      ...product,
      quantity: this.state.selectedQuantity,
      observation: this.state.selectedObservation,
    };
    const currentRows = [...this.state.rows, row];
    const currentTotal = getTotal(currentRows);
    console.log("Add Product", product);
    this.setState({
      rows: currentRows,
      total: currentTotal,
      selectedProduct: 0,
      selectedObservation: "",
      selectedQuantity: 1,
    });
    this.props.updateOrder(currentRows);
    this.state.productRef.focus();
    // This is just a hack to force the clearing of the input field
    setTimeout(() => {
      this.state.productRef.value = "";
    }, 100);
  }

  removeProduct(index: number) {
    const current = [...this.state.rows];
    current.splice(index, 1);
    this.setState({ rows: current });
    this.props.updateOrder(current);
    const newTotal = this.newTotal(current);
    this.setState({ total: newTotal });
  }

  newTotal(items: any) {
    let total = 0;
    items.map((item: any) => {
      total += item.quantity * item.price;
    });
    return total;
  }

  addProductKeyUp(event: any) {
    if (event.key === "Enter") {
      this.addProduct();
    }
  }

  render() {
    const { classes } = this.props;
    let quantityRef: any = null;
    // let observationRef: any = null;
    if (this.state.selectedProduct === null || this.state.products.length < 1) {
      return <p>Cargando...</p>;
    }

    return (
      <Grid container style={{ padding: 20 }}>
        <Grid item lg={12}>
          <div className={classes.addProduct}>
            <FormControl className={classes.formControl}>
              <InputLabel shrink htmlFor="product-name-input">
                Producto:
              </InputLabel>
              <SelectAutocomplete
                options={this.state.products.map((product) => ({
                  label: `${product.category.name} - ${product.name}`,
                  value: product.id,
                }))}
                onSelected={(selectedItem: any) => {
                  this.setState({ selectedProduct: selectedItem.value });
                  if (quantityRef !== null) {
                    quantityRef.focus();
                  }
                }}
                productInputPointer={(target: any) => {
                  this.setState({ productRef: target });
                }}
              />
            </FormControl>
            <FormControl className={classes.formControlQuantity}>
              <InputLabel shrink htmlFor="quantity">
                Cantidad:
              </InputLabel>
              <TextField
                inputRef={(ref) => {
                  quantityRef = ref;
                }}
                id="quantity"
                value={this.state.selectedQuantity}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    selectedQuantity: Number(e.target.value),
                  });
                }}
                onKeyPressCapture={(e) => this.addProductKeyUp(e)}
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                    min: 1,
                    max: 99,
                    style: {
                      textAlign: "center",
                    },
                  },
                }}
                margin="normal"
              />
            </FormControl>

            {/* <FormControl className={classes.formControlObservation}>
              <InputLabel shrink htmlFor="observation">
                Observación:
              </InputLabel>
              <TextField
                inputRef={(ref) => {
                  observationRef = ref;
                }}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
                multiline={true}
                value={this.state.selectedObservation}
                onChange={(e) =>
                  this.setState({
                    ...this.state,
                    selectedObservation: e.target.value,
                  })
                }
                margin="normal"
              ></TextField>
            </FormControl> */}

            <IconButton
              color="primary"
              onClick={this.addProduct}
              // disabled={this.state.selectedProduct === 0}
            >
              <AddShoppingCartIcon />
            </IconButton>
          </div>
        </Grid>
        <Grid item md={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Producto</TableCell>
                {/* <TableCell>Observación</TableCell> */}
                <TableCell numeric>Cantidad</TableCell>
                <TableCell numeric>Precio</TableCell>
                <TableCell numeric>Sub-Total</TableCell>
                <TableCell>Remover</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.rows.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    {/* <TableCell component="th" scope="row">
                      {row.observation}
                    </TableCell> */}
                    <TableCell numeric>{row.quantity}</TableCell>
                    <TableCell numeric>{row.price}</TableCell>
                    <TableCell numeric>{row.price * row.quantity}</TableCell>
                    <TableCell>
                      <IconButton
                        color="primary"
                        onClick={() => this.removeProduct(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>
        <Grid item md={12} className={this.props.classes.gridTotal}>
          {this.state.rows.length > 0 && (
            <Typography variant="caption">
              <b>Total:</b> Gs. {this.state.total}
            </Typography>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles as any)(NewOrderForm);



// WEBPACK FOOTER //
// ./src/components/delivery/NewOrderForm.tsx